// traceRouteUtils.js
import { MapUtils } from '../utils_map/mapUtils'
import { animateRoute } from './routeAnimations.js'

export async function traceRouteForSteps({
  id,
  steps,
  map,
  markersArray,
  routesObj,
  abortController,
}) {
  // abortController?.abort()
  // const controller = new AbortController()
  // // Nettoyage
  // routesObj[id] && delete routesObj[id]
  // for (let i = markersArray.length - 1; i >= 0; i--) {
  //   if (markersArray[i].routeId === id) markersArray.splice(i, 1)
  // }
  // // Marker départ
  // markersArray.push({ position: steps[0].start, isUserPosition: false, routeId: id, options: { title: 'Départ' } })
  // // Construction route principale
  // const routeMain = []
  // for (let i = 0; i < steps.length; i++) {
  //   const s = steps[i]
  //   const sub = await MapUtils.traceRoute(s.start, s.end, [], true)
  //   markersArray.push({ position: s.start, isUserPosition: false, routeId: id, options: { title: `Étape ${i + 1}` } })
  //   sub[0].steps.forEach(st => routeMain.push(...st.detailSteps))
  // }
  // // Marker arrivée
  // markersArray.push({ position: steps[steps.length - 1].end, isUserPosition: false, routeId: id, options: { title: 'Arrivée' } })
  // animateRoute({ routesObj, map, routeId: id, routePoints: routeMain, abortSignal: controller.signal, options })
  // return controller
}

export async function traceRouteFromUser({
  id,
  steps,
  map,
  markersArray,
  routesObj,
  options,
}) {
  let controller = new AbortController()
  routesObj[id] && delete routesObj[id]
  for (let i = markersArray.length - 1; i >= 0; i--)
    if (markersArray[i].routeId === id) markersArray.splice(i, 1)

  let userPos
  try {
    userPos = await MapUtils.getCurrentPosition()
  } catch (error) {
    console.warn(
      "Impossible d'obtenir la position utilisateur pour le tracé de route:",
      error instanceof Error ? error.message : String(error),
    )
    return null
  }
  if (!userPos) return null

  // Route vers le premier step
  const routeToStart = await MapUtils.traceRoute(
    userPos,
    steps[0].start,
    [],
    true,
  )
  markersArray.push({
    position: userPos,
    isUserPosition: true,
    options: { title: 'Départ' },
  })
  markersArray.push({
    position: steps[0].start,
    isUserPosition: false,
    routeId: id,
    options: { title: 'Étape 1' },
  })

  const routeLegs = []

  // Premier leg : utilisateur vers premier point
  const firstLeg = []
  routeToStart[0].steps.forEach(st => firstLeg.push(...st.detailSteps))
  routeLegs.push(firstLeg)

  // Traiter tous les steps comme des legs séparés
  for (let i = 0; i < steps.length; i++) {
    const sub = await MapUtils.traceRoute(
      steps[i].start,
      steps[i].end,
      [],
      true,
    )
    markersArray.push({
      position: steps[i].start,
      isUserPosition: false,
      routeId: id,
      options: { title: `Étape ${i + 1}` },
    })

    const legPoints = []
    sub[0].steps.forEach(st => legPoints.push(...st.detailSteps))
    routeLegs.push(legPoints)
  }
  markersArray.push({
    position: steps[steps.length - 1].end,
    isUserPosition: false,
    routeId: id,
    options: { title: 'Arrivée' },
  })

  animateRoute({
    routesObj,
    map,
    routeId: id,
    routeLegs: routeLegs, // Nouveau paramètre pour les legs séparés
    abortSignal: controller.signal,
    options,
  })
  return controller
}

export async function traceRouteWithPoints({
  id,
  start,
  end,
  checkpoints = [],
  map,
  markersArray,
  routesObj,
  options,
}) {
  let controller = new AbortController()

  // Nettoyer les anciens marqueurs et routes pour cet ID
  if (routesObj[id]) delete routesObj[id]
  for (let i = markersArray.length - 1; i >= 0; i--) {
    if (markersArray[i].routeId === id) markersArray.splice(i, 1)
  }

  // Ajouter les marqueurs
  markersArray.push({
    position: start,
    isUserPosition: false,
    routeId: id,
    content: start.content || '',
    iconType: start.iconType || 'pickup',
    options: { title: start.content || '' },
  })

  checkpoints.forEach((cp, i) => {
    markersArray.push({
      position: cp,
      isUserPosition: false,
      routeId: id,
      content: cp.content || '',
      iconType: cp.iconType || 'checkpoint',
      checkpointNumber: i + 1,
      options: { title: cp.content || '' },
    })
  })

  markersArray.push({
    position: end,
    isUserPosition: false,
    routeId: id,
    content: end.content || '',
    iconType: end.iconType || 'destination',
    options: { title: end.content || 'Destination' },
  })

  try {
    // Tracer la route avec les checkpoints
    const route = await MapUtils.traceRoute(start, end, checkpoints, true)

    // Garder les legs séparés pour avoir des couleurs différentes par segment
    const routeLegs = route.map(leg => {
      const legPoints = []
      leg.steps.forEach(st => legPoints.push(...st.detailSteps))
      return legPoints
    })

    // Animer la route avec les legs séparés
    animateRoute({
      routesObj,
      map,
      routeId: id,
      routeLegs: routeLegs, // Nouveau paramètre pour les legs séparés
      abortSignal: controller.signal,
      options,
    })

    return controller
  } catch (error) {
    controller.abort()
    throw error
  }
}

export async function traceRouteFromUserWithPoints({
  id,
  start,
  end,
  checkpoints = [],
  map,
  markersArray,
  routesObj,
  options,
}) {
  let controller = new AbortController()
  routesObj[id] && delete routesObj[id]
  for (let i = markersArray.length - 1; i >= 0; i--)
    if (markersArray[i].routeId === id) markersArray.splice(i, 1)

  let userPos
  try {
    userPos = await MapUtils.getCurrentPosition()
  } catch (error) {
    console.warn(
      "Impossible d'obtenir la position utilisateur pour le tracé de route:",
      error instanceof Error ? error.message : String(error),
    )
    return null
  }
  if (!userPos) return null

  // Marqueurs
  markersArray.push({
    position: userPos,
    isUserPosition: true,
    routeId: id,
    options: { title: 'Votre position' },
  })
  markersArray.push({
    position: start,
    isUserPosition: false,
    routeId: id,
    content: 'Restaurant',
    iconType: 'pickup',
    options: { title: 'Restaurant' },
  })

  checkpoints.forEach((cp, i) => {
    markersArray.push({
      position: cp,
      isUserPosition: false,
      routeId: id,
      content: `Point de passage ${i + 1}`,
      iconType: 'checkpoint',
      checkpointNumber: i + 1,
      options: { title: `Point de passage ${i + 1}` },
    })
  })

  markersArray.push({
    position: end,
    isUserPosition: false,
    routeId: id,
    content: 'Destination',
    iconType: 'destination',
    options: { title: 'Destination' },
  })

  try {
    // Route utilisateur vers départ
    const routeToStart = await MapUtils.traceRoute(userPos, start, [], true)
    const userLeg = []
    if (routeToStart[0])
      routeToStart[0].steps.forEach(st => userLeg.push(...st.detailSteps))

    // Route principale avec checkpoints
    const route = await MapUtils.traceRoute(start, end, checkpoints, true)
    const mainLegs = route.map(leg => {
      const legPoints = []
      leg.steps.forEach(st => legPoints.push(...st.detailSteps))
      return legPoints
    })

    // Combiner tous les legs dans l'ordre
    const allLegs = [userLeg, ...mainLegs]

    // Animer la route avec les legs séparés
    animateRoute({
      routesObj,
      map,
      routeId: id,
      routeLegs: allLegs, // Nouveau paramètre pour les legs séparés
      abortSignal: controller.signal,
      options,
    })

    return controller
  } catch (error) {
    controller.abort()
    throw error
  }
}
